import { defineMessages } from 'react-intl';

export default defineMessages({
  loginFormUsernamePlaceholder: {
    id: 'login.form.username.placeholder',
    defaultMessage: 'Enter email',
  },
  loginFormUsernameLabel: {
    id: 'login.form.username.label',
    defaultMessage: 'Email',
  },
  loginFormReadOnlyUsernameAriaLabel: {
    id: 'login.form.readonly.username.aria.label',
    defaultMessage: 'Edit email',
  },
});
